import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { defaultAxiosInstance } from "services/client"

import { ResponseData } from "./common"

export type StepStatus = "PENDING" | "IN_PROGRESS" | "COMPLETED" | "FAILED"

export type ImportStep = {
  id: string
  label: string
  status: StepStatus
  order: number
  skip: boolean
  message?: string | null
}

export interface ImportProgressResponseData extends ResponseData {
  data: {
    overallStatus: "IN_PROGRESS" | "COMPLETED" | "FAILED"
    steps: ImportStep[]
  }
}

export interface ImportProgressResponse extends AxiosResponse {
  data: ImportProgressResponseData
}

export interface ImportProgressRequestData {
  pmcId: string
  pmsType: string
}

export interface ImportProgressRequest extends Partial<AxiosRequestConfig> {
  params: ImportProgressRequestData
}

export const getImportProgressUrl = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/hubspot/company-onboarding-status`

export function getImportProgress(
  {
    params,
    method = "get",
    url = getImportProgressUrl,
    ...config
  }: ImportProgressRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<ImportProgressResponse> {
  return axiosInstance({
    params,
    method,
    url,
    ...config,
  }) as Promise<ImportProgressResponse>
}
